import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as debounce from 'lodash.debounce';
import QuickSearchResultHakiSafety from './QuickSearchResultHakiSafety';
import { translate } from '../Services/translation';
import {
    query,
    setSearchQuery,
    toggleShowFullForm,
    handleKeyDown,
    handleClickSearch,
} from '../Actions/QuickSearch.action';
import usePrevious from '@react-hook/previous';
import { toggleQuickSearch } from '../Actions/QuickSearch.action';

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const QuickSearch = () => {
    const { query, result, showResult, showFullForm, selectedItem } = useSelector(
        (state) => state.quickSearch
    );
    const searchUrl =
        window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '');
    const searchContainer = useRef(null);
    useOutsideAlerter(searchContainer);
    const searchInput = useRef(null);
    const dispatch = useDispatch();
    const previousSelectedItem = usePrevious(selectedItem);

    useEffect(() => {
        // set query value if it is avaialble in the Url
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            dispatch(setSearchQuery(query));
        }
    }, [dispatch]);

    useEffect(() => {
        if (selectedItem !== previousSelectedItem) {
            const el = document.querySelector('.quick-search-result__item--selected');
            el &&
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
        }
    }, [selectedItem, previousSelectedItem]);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target) && searchInput) {
                    hideQSR();
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    const hideQSR = () => dispatch(toggleQuickSearch(false));

    const handleInputClick = (e) => {
        if (e.target.value.length > 0) dispatch(toggleQuickSearch(!showResult));
        else hideQSR();
    };

    return (
        <div className="quick-search-hs" role="search" ref={searchContainer}>
            <a className="quick-search-hs__link--block">
                <i className="quick-search-hs__icon" onClick={() => dispatch(toggleShowFullForm())}></i>
                <span className="quick-search-hs__submit-title">
                    {translate('hs.general.search')}
                </span>
            </a>
            <div
                className={`quick-search-hs__form ${showFullForm ? 'quick-search-hs__form--force-show' : ''}`}
                role="search"
            >
                <input
                    className={`quick-search-hs__input ${showResult ? 'show-result' : ''}`}
                    type="search"
                    placeholder={translate('hs.general.search')}
                    autoComplete="on"
                    value={decodeURIComponent(query)}
                    onChange={(event) => {
                        const text = encodeURIComponent(event.target.value);
                        dispatch(setSearchQuery(text));
                        debouncedQuery(dispatch, text);
                    }}
                    onKeyDown={(event) => dispatch(handleKeyDown(event, { searchUrl }))}
                    onClick={handleInputClick}
                    ref={searchInput}               
                />
                <button
                    className="quick-search-hs__submit-button"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                        dispatch(handleClickSearch({ searchUrl }));
                    }}
                >
                    {/*<i className="quick-search-hs__submit-icon"></i>*/}
                    {/*<span className="quick-search-hs__submit-title">{translate('general.search')}</span>*/}
                </button>

                {showResult && (
                    <QuickSearchResultHakiSafety
                        result={result}
                        selectedItem={selectedItem}
                        searchUrl={searchUrl}
                    />
                )}
            </div>
        </div>
    );
};

export default QuickSearch;
